/**
 * Avalara © 2017
 * file: engines/opus_ui/src/App.js
 */

import React, { Component } from 'react';
import Menu from './Menu';
import config from './config';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import LoggedInContainer from './containers/LoggedInContainer';
import queryString from 'query-string';
import { withRouter } from './containers/WithRouter';

const menuItems = config.menuItems.map(item => {
  const titleVersion =
    item.label === 'Status' ? { title: process.env.CI_COMMIT_SHORT_SHA } : {};
  return { ...item, ...titleVersion, callback: this };
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { showing: 'Home' };
  }

  showElement(item) {
    this.setState({ showing: item });
  }

  render() {
    const queryObj = queryString.parse(this.props.router.location.search);
    return (
      <div className="App">
        <div className="App-header">
          <Menu items={menuItems} query={queryObj?.query} />
        </div>
        <Routes>
          <Route path="*" Component={LoggedInContainer} />
        </Routes>
      </div>
    );
  }
}

export default withRouter(App);
